const getDomains = (db, userCollection, userID, onError) => {
  return new Promise((resolve, reject) => {
    if (!userID) return console.log("missing userID")
    db.collection(userCollection)
      .doc(userID)
      .collection("domains")
      .get()
      .then(querySnapshot => {
        if (!querySnapshot.size) resolve([])
        let domains = []
        querySnapshot.forEach(doc => domains.push(doc.data()))
        resolve(domains)
      })
      .catch(error => {
        if (onError) {
          if (onError(error)) {
            getDomains(db, userCollection, userID)
          }
        }
        console.log("Firebase error while loading:", error)
      })
  })
}

export default getDomains
